module.exports = __webpack_public_path__ + "static/media/FantasyCoach_BG_mob.d102e277.jpg";